import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_SALARY_COMPONENT);
var axios_instance_paycomponentDetails = get_axios_instance(api_variables.SERVICE_PAY_COMPONENT_DETAILS);
var axios_instance_calculate = get_axios_instance(api_variables.SERVICE_CALCULATE_SALARY);
var salary_axios_instance = get_axios_instance(api_variables.SERVICE_SALARY_STRUCTURE);
var salarystructure_axios_instance = get_axios_instance(api_variables.SERVICE_EMP_SALARY_STRUCTURE);
var salarycomponents_axios_instance = get_axios_instance(api_variables.SERVICE_EMP_SALARYCOMPONENTS);

const _pk_name = 'id';

const state = {
    entityWiseData: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false
};

const mutations = {
    set: (state, [payload, leId]) => {
        state.entityWiseData[leId] = payload;
        state.entityWiseData = {...state.entityWiseData };
    },

    addEntity: (state, [payload, leId]) => {
        if (!state.entityWiseData[leId]) {
            state.entityWiseData[leId] = [payload];
        } else {
            state.entityWiseData[leId].push(payload);
        }
    },

    updateEntityById: (state, [payload, leId]) => {
        for (let i = 0; i < state.entityWiseData[leId].length; i++) {
            if (state.entityWiseData[leId][i][_pk_name] === payload.id) {
                state.entityWiseData[leId].splice(i, 1, payload);
            }
        }
    },

    removeEntityById: (state, [payload, leId]) => {
        for (let i = 0; i < state.entityWiseData[leId].length; i++) {
            if (state.entityWiseData[leId][i][_pk_name] == payload) {
                state.entityWiseData[leId].splice(i, 1);
            }
        }
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    }
};

const actions = {
    async fetchAll({ commit }, payload) {
        try {
            commit('setFetching', true);
            let res = await axios_instance.get(`/`, {
                params: {
                    le_id: payload
                }
            });
            commit('setFetching', false);
            if (res.status == 200) {
                if (res.data.payload) {
                    if (res.data.payload.data.length) {
                        console.log("hiii")
                       await res.data.payload.data.map((data) => {
                           if (!data.hasOwnProperty("visible_in_it_proof")) {
                                console.log("not there in",data.name)
                                data["visible_in_it_proof"]=false
                            }
                           return data
                        })
                        console.log(res.data.payload.data,"data");
                        commit('set', [res.data.payload.data, payload]);
                    }
                }
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async fetchAllFilterData({ commit }, payload) {
        try {
            commit('setFetching', true);
            let res = await salary_axios_instance.get(`/`, {
                params: {
                    ...payload
                }
            });
            commit('setFetching', false);
            if (res.status == 200) {
                if (res.data.rows.length != 0) commit('set', [res.data.rows.SalaryStructureComponent, payload]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async fetchAllsalaryComponentsData({ commit }, payload) {
        try {
            commit('setFetching', true);
            let res = await salarycomponents_axios_instance.get(`/`, {
                params: {
                    ...payload
                }
            });
            commit('setFetching', false);
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async create({ commit }, payload) {
        try {
            commit('setSaving', true);
            let res = await axios_instance.post('/', payload);
            commit('setSaving', false);
            if (res.status == 201) {
                commit('addEntity', [res.data.payload, payload.data.le_id]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async update({ commit }, payload) {
        try {
            commit('setSaving', true);
            payload.data.taxable = payload.data.pay_type == 'REIMBURSEMENT' ? false : payload.data.taxable 
            let res = await axios_instance.put(`${payload.data.id}`, payload);
            commit('setSaving', false);
            if (res.status == 200) {
                commit('updateEntityById', [res.data.payload, payload.data.le_id]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async paycomponentDetails({ commit }, payload){
        try {
            let res = await axios_instance_paycomponentDetails.get(`?legalEntityId=${payload.legalEntityId}`)
            return res
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async delete({ commit }, payload) {
        try {
            commit('setDeleting', true);
            let res = await axios_instance.delete(`/${payload.id}`);
            commit('setDeleting', false);
            if (res.status == 200) {
                commit('removeEntityById', [payload.id, payload.le_id]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async fetchwithctc({ commit }, payload) {
        try {
            // commit("setFetching", true); params:{...payload}
            let res = await salarystructure_axios_instance.get(`/`, {
                params: payload
            });
            // commit("setFetching", false);
            if (res.status == 200) {
                // commit("set", [res.data.rows, payload]);
                return res.data.payload;
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async calculateSalary({ commit }, payload) {
        try {
            // commit("setFetching", true); params:{...payload}
            let res = await axios_instance_calculate.post(`/`, payload);
            // commit("setFetching", false);
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};